export function initNewsletter() {
    const trigger = document.querySelector('[data-newsletter-popup]');
    if (!trigger) return;

    const status = document.querySelector('[data-newsletter-status]');
    let scriptPromise;

    trigger.addEventListener('click', async (event) => {
        if (trigger.dataset.newsletterReady === 'true') return;
        event.preventDefault();

        if (status) {
            status.textContent = '';
            status.hidden = true;
        }

        if (!scriptPromise) {
            scriptPromise = new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = trigger.dataset.newsletterPopupUrl;
                script.async = true;
                script.onload = resolve;
                script.onerror = () => {
                    script.remove();
                    reject(new Error('Newsletter form failed to load'));
                };
                document.head.append(script);
            });
        }

        trigger.disabled = true;
        trigger.setAttribute('aria-busy', 'true');
        try {
            await scriptPromise;
            trigger.dataset.newsletterReady = 'true';
            window.setTimeout(() => trigger.click(), 100);
        } catch {
            scriptPromise = undefined;
            if (status) {
                status.textContent =
                    'Die Anmeldung konnte nicht geöffnet werden. Bitte erneut versuchen.';
                status.hidden = false;
            }
        } finally {
            trigger.disabled = false;
            trigger.removeAttribute('aria-busy');
        }
    });
}
